/*************************
 * Author : Matthieu ROBIN
 *************************/
import React, { FunctionComponent } from "react";

import CarForm from "../components/CarForm";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";

const CarCreatePage: FunctionComponent = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={true}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      scroll="body"
    >
      <CarForm car={undefined} />
    </Dialog>
  );
};

export default CarCreatePage;
